import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  status: {
    marginTop: 10,
  },
  title: {
    marginTop: 32,
  },
  planBodyItemContainer: {
    marginTop: 20,
  },
  planBodyItemCircle: {
    width: 38,
    height: 38,
    borderRadius: 6.2,
    marginRight: 17,
    marginTop: 8,
  },
  planBodyItemSquare: {
    marginTop: 9,
    width: '100%',
  },
  pricePerMonthContainer: {
    marginTop: 25,
  },

  pricePerMonthValue: {
    width: '90%',
  },
  seperator: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorSix,
    marginTop: 26,
  }),
});
